module.exports = __webpack_public_path__ + "img/kosal.b0c7a042.png";